// Global Instructions Rule Applied!
//
// The "Who can move" picker (Configuration -> Pipelines): Everyone and named
// roles exclude each other. Picking Everyone replaces the roles; picking a role
// while Everyone is chosen replaces Everyone. An empty choice stays empty -
// "admins only" (admins pass every rule; docs/USER_RIGHTS_DESIGN.md).
export function nextMoveRoleIds(previous: string[], next: string[], everyoneRoleId: string | null): string[] {
  if (everyoneRoleId === null) return next
  const addedEveryone = next.includes(everyoneRoleId) && !previous.includes(everyoneRoleId)
  if (addedEveryone) return [everyoneRoleId]
  return next.length > 1 ? next.filter((id) => id !== everyoneRoleId) : next
}
